import {defineStore} from "pinia";
import http from "../api/http";
import {ElMessage} from "element-plus";

export const useProducts = defineStore('products', {
    state: () => ({
        productsList: [],
        productDetail: [],
    }),
    getters: {
        getProductsList: (state) => state.productsList,
        getProductDetail: (state) => state.productDetail,
    },
    actions: {
        productsListApi() {
            http.productsList().then(res => {
                this.productsList = res.data
            })
        },
        //获取产品详情
        productDetailApi(id) {
            http.productDetail({id}).then(res => {
                this.productDetail = res.data
            })
        },
        // 购买产品
        buyProductApi(products_id, number, cb) {
           http.productsBuy({products_id, number}).then(res => {
               ElMessage({
                   duration: 1500,
                   message: res.msg,
                   type: 'success',
                   onClose: () => {
                       cb(true)
                   }
               })
           }).catch(err => {
               ElMessage({
                   duration: 1500,
                   message: err.msg,
                   type: 'error',
                   onClose: () => {
                       cb(true)
                   }
               })
           })
        }
    }
})
